import { motion } from "framer-motion";
import styled from "styled-components";

export const FinishedView = styled(motion.div)`
  display: flex;
  flex-direction: column;
  margin: 0 auto 32px;
  max-width: 868px;
  height: auto;
`;

export const ConfirmationBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 43px;
  padding: 0 55px;

  @media screen and (width < 600px) {
    flex-direction: column;
  }

  p,
  a {
    color: #95959d;
    text-align: center;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
  }

  a:hover {
    color: #000;
    text-decoration: underline;
  }
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 28px;
  margin: 62px auto 0;
  width: 90%;

  div {
    display: flex;
    flex-direction: column;
    color: #000;
    font-family: Rubik;
    font-style: normal;

    h1 {
      font-size: clamp(1.875rem, 1.6691rem + 0.4706vw, 2.375rem);
      font-weight: 500;
      line-height: 47px;
      letter-spacing: -0.76px;
      margin: 0;
      text-wrap: pretty;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;
    }
  }
`;

export const CollapseHeaderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 135px;
  cursor: pointer;

  // arrow
  > svg {
    transition: transform 0.3s ease;
    transform: ${({ active }) => (active ? "rotate(0deg)" : "rotate(-90deg)")};
  }

  svg g path,
  div svg path {
    transition: stroke 0.3s ease;
    stroke: ${({ active }) => (active ? "#1e22ff" : "#000")};
  }

  > div {
    transition: color 0.3s ease;
    color: ${({ active }) => (active ? "#1e22ff" : "#000")};
    font-weight: 400; // can't animate font-weight
    font-family: Rubik;
    font-size: 23px;
    font-style: normal;
    line-height: 32px;
    letter-spacing: -0.46px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const WhatsNextContent = styled.div`
  margin: 28px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Step = styled.div`
  width: 100%;
  border-radius: 5px;
  border-radius: 5px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 26%, rgba(255, 255, 255, 0.8) 46%);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  margin-bottom: 11px;
`;

export const TextBox = styled.div`
  padding: 18px 24px;

  h2 {
    color: #000;
    margin: 0;
    font-family: Rubik;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 25px;
    text-align: left;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
  }

  p {
    color: #121214;
    font-family: Rubik;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
  }
`;

export const StepOne = styled(Step)`
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const StepTwo = styled(Step)`
  img {
    width: 100%;
  }
`;

export const StepThree = styled(Step)`
  img {
    padding: 5px 28px;
  }
`;

export const BookNewSection = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  margin-top: 33px;
  margin-left: 140px;

  color: #1e22ff;
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.04);
    text-decoration: underline;
    color: #1e22ff;
  }
`;
